// import React from "react";
// import PlayerAvatar from "./PlayerAvatar";
// import { useTranslation } from "react-i18next";

// const PodiumCard = ({ name, profile_url, RankImage, gradient, points ,StarRank , blueDiv }) => {
//   const {t} = useTranslation();
//   return (
//     <div className="flex flex-col items-center">
//       <div
//         className="flex flex-col items-center mb-0 w-[170px] md:w-[200px] rounded-2xl"
//         style={{
//           background: gradient,
//         }}
//       >
//         <div className="relative pt-8 w-full">
//           <PlayerAvatar
//             name={name}
//             imageUrl={profile_url}
//             // size="lg"
//           />
//           {/* Rank bookmark for 3rdplace */}
//           {/* <div className="absolute top-0 right-5">
//             {RankImage}
//           </div> */}
//         </div>
//         <p className="text-white text-[16px] font-[Lato] text-center max-w-[150px] truncate">
//           {name || "Unknown Player"}
//         </p>
//         <div className="mt-1 mb-4">
//           <div className="bg-white rounded-full px-2 py-1 flex items-center gap-2">
//             {StarRank} 
//             <p className="text-[#BFBFBF] text-[14px] font-[Lato] font-[600]">
//               {points || 0} {t("Points")}
//             </p>
//           </div>
//         </div>
//       </div>
//       {/* Podium base */}
//       {blueDiv}
//     </div>
//   );
// };

// export default PodiumCard;

import React from "react";
import PlayerAvatar from "./PlayerAvatar";
import { useTranslation } from "react-i18next";
import useMediaQueryHook from "@hooks/useMediaQueryHook";

const PodiumCard = ({ name, profile_url, RankImage, gradient, points, StarRank, blueDiv }) => {
  const { t } = useTranslation();
  const {isMobile} = useMediaQueryHook()
  return (
    <div className="flex flex-col items-center w-full max-w-[110px] md:max-w-[200px]">
      <div
        className="flex flex-col items-center mb-0 w-full rounded-2xl"
        style={{
          background: isMobile ? "transparent":gradient,
        }}
      >
        <div className="relative pt-4 md:pt-8 w-full flex justify-center">
          {/* Responsive Avatar size: 
              Ensure PlayerAvatar handles a size prop or use a className 
          */}
          <div className="scale-[0.85] md:scale-100 origin-bottom pt-3 md:pt-8">
            <PlayerAvatar
              name={name}
              imageUrl={profile_url}
              size="md" 
            />
          </div>
        </div>

        {/* Text Container */}
        <div className="flex flex-col items-center w-full px-1 pb-1 md:pb-3 md:pb-4">
          <p className="text-white text-[11px] md:text-[16px] font-[Lato] text-center w-full truncate mb-1">
            {name || "Unknown Player"}
          </p>
          
          {/* Points Pill: Very compact on mobile to prevent overflow */}
          <div className="bg-white rounded-full px-1.5 py-0.5 md:px-2 md:py-1 flex items-center justify-center gap-1 min-w-[75px] md:min-w-[100px] shadow-sm">
            <div className="w-3 h-3 md:w-5 md:h-5 flex items-center justify-center">
              {StarRank}
            </div>
            <p className="text-[#FBB03B] text-[9px] md:text-[14px] font-[Lato] font-[700] whitespace-nowrap">
              {points || 0} <span className="text-[#BFBFBF] font-[500]">{t("Points")}</span>
            </p>
          </div>
        </div>
      </div>

      {/* Podium base (1st, 2nd, 3rd boxes) */}
      {/* <div className="w-full"> */}
        {blueDiv}
      {/* </div> */}
    </div>
  );
};

export default PodiumCard;